import React, { memo } from 'react';
import SvgIcon from '@home/components/SvgIcon';
import BasicImage from '@home/components/BasicImage';
import AigcEllipsisHover from '@/pages/aigc/components/EllipsisHover';
import { useIntl } from 'umi';
import OpinionReportIcon from '../../../../../assets/svg/opinion-report-card.svg';
import type { IOpinionReportCardItem } from '../../types/history';

interface IOpinionReportCardProps {
  value?: IOpinionReportCardItem[];
  messageId?: string;
}

const OpinionReportCardItem = ({
  cardValue,
}: {
  cardValue: IOpinionReportCardItem;
}) => {
  const { opinion_path, display_text, image_url, icon } = cardValue || {};
  const { formatMessage } = useIntl();

  const displayTitle = display_text || '-';
  const linkText = formatMessage({ id: 'dba_opinion_report_card_link' });
  const coverImage = image_url || icon || OpinionReportIcon;

  const handleClick = (): void => {
    if (!opinion_path) {
      return;
    }
    const targetUrl = `${window.location.origin}/${opinion_path.replace(/^\//, '')}`;
    window.open(targetUrl, '_blank');
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="dba-opinion-report-card"
      role="button"
      tabIndex={opinion_path ? 0 : -1}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div className="dba-opinion-report-card-content">
        <div className="dba-opinion-report-card-icon">
          <BasicImage
            src={coverImage}
            errorSrc={OpinionReportIcon}
            alt={displayTitle}
          />
        </div>
        <div className="dba-opinion-report-card-info">
          <AigcEllipsisHover
            className="dba-opinion-report-card-title"
            text={displayTitle}
          />
          <div className="dba-opinion-report-card-link">
            <AigcEllipsisHover
              className="dba-opinion-report-card-link-text"
              text={linkText}
            />
            <SvgIcon
              className="dba-opinion-report-card-link-icon"
              type="aigc-share"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * 舆情分析报告卡片组件
 * 渲染游戏报告引导卡片网格
 */
export const OpinionReportCardCmp = memo(
  (props: IOpinionReportCardProps) => {
    const cardList = props.value || [];

    if (!cardList.length) {
      return null;
    }

    return (
      <div className="dba-opinion-report-card-list">
        {cardList.map((cardValue, index) => (
          <OpinionReportCardItem key={index} cardValue={cardValue} />
        ))}
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.messageId === nextProps.messageId &&
    prevProps.value === nextProps.value,
);

OpinionReportCardCmp.displayName = 'OpinionReportCardCmp';
